import { render } from "./CreateLocationPointView.vue?vue&type=template&id=cd84cd64&scoped=true"
import script from "./CreateLocationPointView.vue?vue&type=script&lang=js"
export * from "./CreateLocationPointView.vue?vue&type=script&lang=js"

import "./CreateLocationPointView.vue?vue&type=style&index=0&id=cd84cd64&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd84cd64"]])

export default __exports__